// @ts-nocheck
import { isEmpty } from 'lodash';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { checkUserResourcePermissions } from 'sonata-static-storage/lib/helpers/user.helpers';

import { getBaseCurrency } from '@/store/selectors/baseCurrency.selectors';
import { getCurrency } from '@/store/selectors/reportingAdvancedFilter.selectors';
import { CampaignsStyle } from '@/ts-modules/reporting/Header/Campaigns/campaigns.style';
import CampaignsList from '@/ts-modules/reporting/Header/Campaigns/Multi/components/CampaignsList/CampaignsList';
import { Multi } from './Multi';
import { Single } from './Single';

import type { BaseCurrencyInterface } from 'sonata-static-storage/lib/schemas/baseCurrency/baseCurrency.schema';
import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import type { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';
import type { CampaignItem } from '@/ts-modules/reporting/CampaignListSelector/CampaignListSelector';

type Props = {
  backupsDataDisclaimerEnabled?: boolean;
  campaigns: CampaignItem[];
  user: UserInterface;
  userRoles: UserRoleInterface[];
};

function Campaigns({ backupsDataDisclaimerEnabled = false, campaigns, user, userRoles }: Props) {
  // @ts-ignore
  const currentCurrency = useSelector(store => getCurrency(store, 'general'));
  // @ts-ignore
  const currencyInfo: BaseCurrencyInterface = useSelector(store => getBaseCurrency(store, currentCurrency));

  const campaignsBottomPanelPermission = checkUserResourcePermissions('reportingHeaderBottomPanel', user, userRoles);
  const reportingHeaderPermission = checkUserResourcePermissions('reportingHeader', user, userRoles);

  const type = campaigns.length === 1 ? 'single' : 'multi';
  const data = type === 'single' ? campaigns[0] : campaigns;

  const [{ dataSelectedCampaigns }, setState] = useState({
    dataSelectedCampaigns: campaigns
  });

  if (!dataSelectedCampaigns.length && campaigns.length > 0) {
    setState(prevState => ({
      ...prevState,
      dataSelectedCampaigns: campaigns
    }));
  }

  const onSelectedCampaign = (items: CampaignItem[]) => {
    setState(prevState => ({
      ...prevState,
      dataSelectedCampaigns: items
    }));
  };

  if (!campaigns.length || isEmpty(currencyInfo)) {
    return null;
  }

  return (
    <>
      <CampaignsStyle backupsDataDisclaimerEnabled={backupsDataDisclaimerEnabled} className="reportingCampaigns">
        {reportingHeaderPermission && (
          <div className="reportingCampaigns__container">
            {type === 'single' ? (
              <Single currencyInfo={currencyInfo} data={data} />
            ) : (
              <Multi
                currencyInfo={currencyInfo}
                data={data as CampaignItem[]}
                onSelectedCampaign={onSelectedCampaign}
              />
            )}
          </div>
        )}
      </CampaignsStyle>
      {type === 'multi' && campaignsBottomPanelPermission && (
        <CampaignsList currencyInfo={currencyInfo} dataSelectedCampaigns={dataSelectedCampaigns} />
      )}
    </>
  );
}

export default Campaigns;
